import { UsersI } from '../interfaces/users.interface'
import { UsersService } from '../services/users.service'
import {
    BillingGetPeriodsResponseT,
    EmployeePayloadT,
    ProfileResponseT,
    UpdateUserPayloadT,
    UserPayloadT,
    UsersChangeStatusPayload,
    UsersCreateEmployeeResponseT,
    UsersCreateUserResponseT,
    UsersGetDictionaryResponseT,
    UsersGetEmployeeResponseT,
    UsersGetEmployeesFiltersT,
    UsersGetEmployeesResponseT,
    UsersGetInitiatorsParams,
    UsersGetInitiatorsResponseT,
    UsersGetListFilters,
    UsersGetListResponseT,
    UsersGetManagersParams,
    UsersGetManagersResponseT,
    UsersGetTokenResponseT,
    UsersGetUserResponseT,
    UsersUpdateEmployeeResponseT,
    UsersUpdateUserResponseT,
} from '../types/users.types'

const usersService = new UsersService()

class UsersRealisation implements UsersI {
    getList(filters: UsersGetListFilters): Promise<UsersGetListResponseT> {
        return usersService.getList(filters)
    }

    getDictionary(type: number, description?: string): Promise<UsersGetDictionaryResponseT> {
        return usersService.getDictionary(type, description)
    }

    getEmployees(filters: UsersGetEmployeesFiltersT): Promise<UsersGetEmployeesResponseT> {
        return usersService.getEmployees(filters)
    }

    getUserFromCabinet(user_id: number): Promise<UsersGetUserResponseT> {
        return usersService.getUserFromCabinet(user_id)
    }

    getEmployee(id: number): Promise<UsersGetEmployeeResponseT> {
        return usersService.getEmployee(id)
    }

    getDispatchers(page: number, name?: string, limit?: number): Promise<UsersGetListResponseT> {
        return usersService.getDispatchers(page, name, limit)
    }

    getAccountants(page: number, name?: string, statusId?: number): Promise<UsersGetListResponseT> {
        return usersService.getAccountants(page, name, statusId)
    }

    getLogists(
        page: number,
        name?: string,
        isExtended?: number,
        statusId?: number,
        limit?: number
    ): Promise<UsersGetListResponseT> {
        return usersService.getLogists(page, name, isExtended, statusId, limit)
    }

    createUser(payload: UserPayloadT): Promise<UsersCreateUserResponseT> {
        return usersService.createUser(payload)
    }

    createEmployee(payload: EmployeePayloadT): Promise<UsersCreateEmployeeResponseT> {
        return usersService.createEmployee(payload)
    }

    updateUser(user_id: number, payload: UpdateUserPayloadT): Promise<UsersUpdateUserResponseT> {
        return usersService.updateUser(user_id, payload)
    }

    updateEmployee(id: number, payload: EmployeePayloadT): Promise<UsersUpdateEmployeeResponseT> {
        return usersService.updateEmployee(id, payload)
    }

    updateUserInCabinet(
        user_id: number,
        payload: UpdateUserPayloadT
    ): Promise<UsersUpdateUserResponseT> {
        return usersService.updateUserInCabinet(user_id, payload)
    }

    deleteUser(user_id: number): Promise<void> {
        return usersService.deleteUser(user_id)
    }

    deleteEmployee(id: number): Promise<void> {
        return usersService.deleteEmployee(id)
    }

    getManagers(params: UsersGetManagersParams): Promise<UsersGetManagersResponseT> {
        return usersService.getManagers(params)
    }

    getInitiators(params: UsersGetInitiatorsParams): Promise<UsersGetInitiatorsResponseT> {
        return usersService.getInitiators(params)
    }

    getBillingPeriods(page: number): Promise<BillingGetPeriodsResponseT> {
        return usersService.getBillingPeriods(page)
    }

    getUserToken(user_id: number): Promise<UsersGetTokenResponseT> {
        return usersService.getUserToken(user_id)
    }

    changeStatus(payload: UsersChangeStatusPayload): Promise<void> {
        return usersService.changeStatus(payload)
    }

    getProfile(): Promise<ProfileResponseT> {
        return usersService.getProfile()
    }
}

export const users = new UsersRealisation()
